import trashIcon from '@jetbrains/icons/trash.svg'
import Button from '@jetbrains/ring-ui/components/button/button'
import React from 'react'

import styles from '../MatrixParamBuild.css'
import MatrixParamBuildParameterValues from '../MatrixParamBuildParameterValues/MatrixParamBuildParameterValues'

import MatrixParamBuildParameterSelect from './MatrixParamBuildParameterSelect/MatrixParamBuildParameterSelect'
import useMatrixParamBuildParameters from './useMatrixParamBuildParameters'

type MatrixParamBuildParametersRrops = {
  isReadOnlyMode: boolean
}

function MatrixParamBuildParameters({isReadOnlyMode}: MatrixParamBuildParametersRrops) {
  const {
    parameters,
    isAllowDelete,
    restoreParameters,
    parameterDuplicates,
    parameterSelectOptions,
    parameterValuesOptions,
    latestInputParamNameRef,
    clickAddParameterButtonHandler,
    deleteParameterButtonClickHandler,
    restoreParameterButtonClickHandler,
    deletePermanentlyParameterButtonClickHandler,
    parameterSelectHints,
  } = useMatrixParamBuildParameters()

  return (
    <div className={styles.form}>
      {parameters.map((parameter, index) => {
        const deletedParameterName = restoreParameters[index]
        const parametersLength = parameters.length
        const key = `${index}-${parametersLength}`

        if (!parameter && !deletedParameterName?.name) {
          return null
        }

        if (!parameter) {
          const restoreParameterName =
            parameterValuesOptions.get(deletedParameterName!.name)?.displayName ??
            deletedParameterName?.name

          return (
            <div className={styles.resotre} key={key}>
              {`You have deleted the parameter <${restoreParameterName}>. Do you want to restore it?`}
              <div>
                <Button inline text onClick={restoreParameterButtonClickHandler(index)}>
                  {'Restore'}
                </Button>

                <Button
                  className={styles.resotreDeletePermanently}
                  primary
                  inline
                  text
                  onClick={deletePermanentlyParameterButtonClickHandler(index)}
                >
                  {'Delete permanently'}
                </Button>
              </div>
            </div>
          )
        }
        const isDuplicate = Boolean(parameterDuplicates.get(parameter.name ?? ''))
        const parameterValuesSelectOptions = parameterValuesOptions.get(parameter.name ?? '')
        const parameterHint = parameterSelectHints.get(parameter.name ?? '')
        const isLast = index === parametersLength - 1
        const matrixParamBuildParameterSelectRef = isLast ? latestInputParamNameRef : null

        return (
          <div key={key} className={styles.parameter}>
            <div className={styles.parameterName}>
              <div className={styles.row}>
                <MatrixParamBuildParameterSelect
                  options={parameterSelectOptions}
                  isDuplicate={isDuplicate}
                  value={parameter.name}
                  index={index}
                  hint={parameterHint}
                  disabled={isReadOnlyMode}
                  ref={matrixParamBuildParameterSelectRef}
                />
                {isAllowDelete && (
                  <div className={styles.deleteButton}>
                    <Button
                      onClick={deleteParameterButtonClickHandler(parameter, index)}
                      icon={trashIcon}
                      title="Delete parameter"
                      disabled={isReadOnlyMode}
                    />
                  </div>
                )}
              </div>
            </div>

            <MatrixParamBuildParameterValues
              parameterIndex={index}
              options={parameterValuesSelectOptions?.value}
              values={parameter.value}
              disabled={isReadOnlyMode}
            />
          </div>
        )
      })}
      <Button onClick={clickAddParameterButtonHandler} disabled={isReadOnlyMode}>
        {'Add parameter'}
      </Button>
    </div>
  )
}

export default MatrixParamBuildParameters
